/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React, { useState, useEffect, Fragment } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import axiosInstance from "../../helpers/axiosInstance";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { cambiasidebar } from "../../Slicersreducers.js";
import basePerfiles from "../../views/siif/basePerfiles.js";
import CreateLinks from "./CreateLinks";
const _ = require("lodash");

var ps;

const Sidebar = (props) => {
  const [perfiles, setperfiles] = useState(basePerfiles);
  const [permisos, setpermisos] = useState([
    { name: "Transacciones Masivas", habil: false },
  ]);
  const [collapseOpen, setCollapseOpen] = useState();
  const activsidebar = useSelector((state) => state.miga.sidebaractiv);
  const ipredux = useSelector((state) => state.miga.ultimaip);
  const fechaingresoredux = useSelector((state) => state.miga.fechultingreso);
  const nombreclienteredux = useSelector((state) => state.miga.nombreCliente);

  const dispatch = useDispatch();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse

  // creates the links that appear in the left menu / Sidebar
  /*const CreateLinks = (props) => {
    let cargando=false;
    const closeCollapse = (prop,key) => {
      cargando=true;
      //console.log("close colapse" + key +  prop.linkActive + routes.length);  
      dispatch(cambiasidebar(true)); 
      
      routespermitidos[key].linkActive=true;
      
      for (let i=0 ; i<routespermitidos.length; i++)
      {
        if (i!=key)
        {
          routespermitidos[i].linkActive=false;
        }
      }
      cargando=false;
      //console.log("close colapse-1-" +  prop.linkActive);    
      //setCollapseOpen(false);
    };
    console.log("sidebar");
    
    let routes = props.routes.filter(r => r.profile.includes("transaccion"));
    let routesvisible=routes.filter(item=>!item.invisible);
    let routespermitidos=[];
    
    routesvisible.map((item)=>{
      let posicionpermiso=-1;
      for(let i=0;i<permisos.length;i++){
        if(permisos[i].name==item.name){
          posicionpermiso=i;
          i=permisos.length;
        }
      }
      if(posicionpermiso==-1){
        routespermitidos.push(item);
      }else{
        if(permisos[posicionpermiso].habil){
          routespermitidos.push(item);
        }
      }
    })
    
    console.log(routespermitidos);
    if(cargando==false){
      return(
        <Fragment>
          {routespermitidos.map((item,index)=>{
            if(item.linkActive==false || activsidebar==false){
              return (          
                <NavItem key={index}>
                  <NavLink
                    to={item.layout + item.path}
                    tag={NavLinkRRD}
                    onClick={() => closeCollapse(item,index)}
                    activeClassName=""
                  >
                    {/*<i className={prop.icon} />/}
                    <i>              
                        <img style={{height:"20px"}} src={item.icon}></img>
                    </i>
                    {item.name}
                  </NavLink>
                </NavItem>
              );
  
            }else{
              return (
                <NavItem key={index}>
                  <NavLink
                    to={item.layout + item.path}
                    tag={NavLinkRRD}
                    onClick={() => closeCollapse(item,index)}
                    activeClassName="active"
                  >              
                    <i>              
                      <img style={{height:"20px", }} src={item.icon_active}></img>
                    </i> 
                    {item.name}
                  </NavLink>
                </NavItem>
              );
  
            }
          })}
        </Fragment>
      )

    }else{
      return(<Fragment></Fragment>)
    }
    
    /*
    return routes.map((prop, key) => {
      if (prop.invisible) return null
      let posicionpermiso=-1;
      for(let i=0;i<permisos.length;i++){
        if(permisos[i].name==prop.name){
          posicionpermiso=i;
          i=permisos.length;
        }
      }
      let muestraopc=false;
      if(posicionpermiso==-1){
        muestraopc=true;
      }else{
        if(permisos[posicionpermiso].habil){
          muestraopc=true;
        }
      }
      //console.log(permisos);
      if(muestraopc){
        if (opcactiv==key || activsidebar==false)
        {
          return (          
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={() => closeCollapse(prop,key)}
                activeClassName=""
              >
                {/*<i className={prop.icon} />}
                <i>              
                    <img style={{height:"20px"}} src={prop.icon}></img>
                </i>
                {prop.name}
              </NavLink>
            </NavItem>
          );
        }
        else
        {
          return (
            <NavItem key={key}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={() => closeCollapse(prop,key)}
                activeClassName="active"
              >              
                <i>              
                  <img style={{height:"20px", }} src={prop.icon_active}></img>
                </i> 
                {prop.name}
              </NavLink>
            </NavItem>
          );
        }

      }else{
        return null
      }
      
    });
  };*/

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }
  const logOut = async () => {
    const user = {
      IDType: parseInt(getCookie("tid")),
      NID: parseInt(getCookie("nid")),
      Longitude: "-122.40641",
      Latitud: "37.785834",
    };
    const request = await axiosInstance()
      .post("/WSGYG39_2/api/Users/Logout", user)
      .catch((err) => {
        return "err";
      });
    if (request != "err") {
      window.location = "/BancaVirtual/";
      console.log(request.data);
    }
    return request;
  };

  const getCookie = (name) => {
    let matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
          "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  const [DateLastLog, setDateLastLog] = useState();
  const [IpLastLog, setIpLastLog] = useState();
  useEffect(() => {
    const perfilCookie = getCookie("TEMPORAL");
    //console.log("cookie temporal " + perfilCookie);
    let permitido = false;
    if (perfilCookie) {
      for (let i = 0; i < perfiles.length; i++) {
        if (
          perfiles[i].nombrePerfil == "Preparador" ||
          perfiles[i].nombrePerfil == "Estándar" ||
          perfiles[i].nombrePerfil == "Aprobador" ||
          perfiles[i].nombrePerfil == "Seguridad"
        ) {
          //if(perfilCookie.length>i){
          //console.log(perfilCookie.substring(i,i+1));
          if (
            perfilCookie.substring(1, 2) == "1" ||
            perfilCookie.substring(3, 4) == "1"
          ) {
            //console.log("Perfil habilitado TM");
            permitido = true;
          } else {
            //console.log("perfil inhabilitado TM");
            permitido = false;
          }
          // }
          i = perfiles.length;
        }
      }
    } else {
      //console.log("no se encuetra cookie");
      permitido = false;
    }
    //console.log("permisos");
    if (permitido) {
      let copiapermisos = _.cloneDeep(permisos);
      for (let i = 0; i < copiapermisos.length; i++) {
        if (copiapermisos[i].name == "Transacciones Masivas") {
          copiapermisos[i].habil = true;
          i = copiapermisos.length;
        }
      }
      console.log(copiapermisos);
      setpermisos(_.cloneDeep(copiapermisos));
    }
    /*
    async function getProducts() {
      const request = await axiosInstance()
        .get("/WSGYG39_2/api/Inquiries/Products")
        .catch((err) => {
          return "err";
        });
      if (request != "err") {
        console.log("respuesta sidebar"+ request.data.dateLastLog);
       
        setDateLastLog(request.data.dateLastLog);
        setIpLastLog(request.data.ipLastLog);
      }
      return request;
    }
    
    getProducts();
    */

    setDateLastLog(fechaingresoredux);
    setIpLastLog(ipredux);
  }, []);

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white navbar navbar-expand-md"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
            />
          </NavbarBrand>
        ) : null}
        {/* User */}
        <Nav className="align-items-center d-md-none">
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt="..."
                    src={
                      require("../../assets/img/theme/Icono persona.jpg")
                        .default
                    }
                  />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem className="noti-title" header tag="div">
                <h6 className="text-overflow m-0">Welcome!</h6>
              </DropdownItem>
              <DropdownItem to="/admin/contacts" tag={Link}>
                <i className="ni ni-single-02" />
                <span>Contactos</span>
              </DropdownItem>
              <DropdownItem to="/admin/security" tag={Link}>
                <i className="ni ni-settings-gear-65" />
                <span>Seguridad</span>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem href="" onClick={() => logOut()}>
                <i className="ni ni-user-run" />
                <span>Salida segura</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Form */}

          {/* Navigation */}
          <Nav navbar>
            <CreateLinks routes={routes} permisos={permisos}></CreateLinks>
          </Nav>
          {/* Footer Menu */}
          {console.log(props)}
          {console.log(props.location.state)}
          {/*console.log(props.location.state.DateLastLog)        */}
          <div
            className="m-0"
            style={{
              position: "absolute",
              bottom: "0px",
              top: "85%",
              minWidth: "auto",
            }}
          >
            <h5 className="text-dark">
              Bienvenido:
              <br /> {nombreclienteredux}
            </h5>
            <h6 className="text-dark">
              Fecha último login: {fechaingresoredux}
            </h6>
            <h6 className="text-dark">Ip último login: {ipredux}</h6>
            {/*<h6 className="text-primary">Fecha Ultimo Logeo: {getCookie("dateLastLog")}</h6>
            <h6 className="text-primary">Ip Ultimo Logeo: {getCookie("ipLastLog")}</h6>*/}
          </div>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
